import moment from "moment";
import { uuid } from "vue-uuid";

export default {
    mixins: [],
    data: () => ({
        //This give us the current, position from the api result to get and send to zip converter.
        mediaPagesPosition: 0,
    }),
    computed: {},
    methods: {
        infoStartDownload(url, isZip = false) {
            const extension = isZip ? "zip" : this.getExtensionFile(url);
            const mimeType = this.getMimeType(extension);
            const fullName = this.getFullname(url);
            const contentLength = 0;
            const idx = this.addNewDownload({
                url,
                contentLength,
                fullName,
                mimeType,
                url: null
            });
            return idx;
        },
        /* The above code is concatenating the arrays. */
        concatenate(arrays) {
            if (!arrays.length) return null;
            let totalLength = arrays.reduce(
                (acc, value) => acc + value.length,
                0
            );
            let result = new Uint8Array(totalLength);
            let length = 0;
            for (let array of arrays) {
                result.set(array, length);
                length += array.length;
            }
            return result;
        },
        /* Getting the content length of a file. */
        getContentLength(url) {
            return new Promise((resolve, reject) => {
                let xhr = new XMLHttpRequest();
                xhr.open("GET", url);
                xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
                xhr.send();
                xhr.onload = function () {
                    resolve(
                        ~~xhr.getResponseHeader("Content-Length")
                    );
                };
                xhr.onerror = reject;
            });
        },
        /* The above code is using the XMLHttpRequest object to make a request to the server. The
        request is made to the url that is passed in. The request is made using the GET method. The
        request is made for a specific range of bytes. The response type is set to arraybuffer. The
        onload function is called when the request is successful. The resolve function is called
        with the index of the file block and the buffer of the response. The send function is called
        to send the request. */
        getBinaryContent(url, start, end, i) {
            return new Promise((resolve, reject) => {
                try {
                    let xhr = new XMLHttpRequest();

                    xhr.open("GET", url, true);
                    xhr.setRequestHeader("range", `bytes=${start}-${end}`); // Set range request information
                    xhr.responseType = "arraybuffer"; // Set the returned type to arraybuffer

                    xhr.onload = function () {
                        resolve({
                            index: i, // file block index
                            buffer: xhr.response,
                        });
                    };

                    xhr.send();
                } catch (err) {
                    reject(new Error(err));
                }
            });
        },
        /* The above code is creating a blob object and then creating a link to download the file. */
        saveAs({ idx, buffers, mime = "application/octet-stream" }) {
            const name = this.$store.state.downloaded.data[idx].name;
            const mimeType =
                this.$store.state.downloaded.data[idx].mimeType.mime;
            const blob = new Blob([buffers], { type: mimeType });
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.download = name || Math.random();
            a.href = blobUrl;
            a.click();
            URL.revokeObjectURL(blob);
        },
        /* The above code is a function that takes in three parameters: concurrency, iterable, and
        iteratorFn. The function returns a promise that resolves when all the asynchronous tasks are
        completed. */
        async asyncPool(concurrency, iterable, iteratorFn) {
            const ret = []; // Store all asynchronous tasks
            const executing = new Set(); // Stores executing asynchronous tasks
            for (const item of iterable) {
                // Call the iteratorFn function to create an asynchronous task
                const p = Promise.resolve().then(() =>
                    iteratorFn(item, iterable)
                );

                ret.push(p); // save new async task
                executing.add(p); // Save an executing asynchronous task

                const clean = () => executing.delete(p);
                p.then(clean).catch(clean);
                if (executing.size >= concurrency) {
                    // Wait for faster task execution to complete
                    await Promise.race(executing);
                }
            }
            return Promise.all(ret);
        },
        /* Downloading a file in chunks and updating the progress bar. */
        async binaryContentDowloaded(binaryContent, idx) {
            const response = await binaryContent;
            const contentLength =
                this.$store.state.downloaded.data[idx].contentLength;
            const byteLength =
                this.$store.state.downloaded.data[idx].byteLength;
            let byteLengthAmount = byteLength + response.buffer.byteLength;
            // this.$store.dispatch("setDownloadByteLength", byteLength);

            let porcentDownload = (byteLength / contentLength) * 100;
            porcentDownload = Math.floor(porcentDownload);
            // this.$store.dispatch("setDownloadProgress", porcentDownload);

            let data = {
                byteLength: byteLengthAmount,
                porcent: porcentDownload,
            };
            this.$store.dispatch("setNewDataDownloaded", { idx, data });
        },
        /* Creating a new download item and adding it to the store. */
        addNewDownload(arg) {
            const uuidV1 = uuid.v1();
            /**
             * Todo: this should be refactor or find a better way to difine the fullname
             */
            const fullName = arg.mimeType.type == 2 ? arg.fullName + '.zip' : arg.fullName;
            const data = {
                uuid: uuidV1,
                name: fullName,
                byteLength: 0,
                contentLength: arg.contentLength,
                sizeFormat: this.formatBytes(arg.contentLength),
                porcent: 0,
                mimeType: arg.mimeType,
                state: null,
            };
            // Agregamos el item que estaremos usando para actualizar su propoedades
            this.addDownloadFile(data);

            // obtenemos el index para retornarlo y poder asignarle sus valores en vuelo
            const idx = Object.values(
                this.$store.state.downloaded.data
            ).findIndex((item) => item.uuid == uuidV1);
            return idx;
        },
        addDownloadFile(multimedio) {
            let downloadFiles = Object.values(
                this.$store.state.downloaded.data
            );

            downloadFiles = [multimedio, ...downloadFiles];
            this.$store.dispatch("setDownloaded", downloadFiles);
        },
        /* Creating a new zip file and adding it to the store. */
        addNewCompressedZip(filename) {
            const uuidV1 = uuid.v1();
            const data = {
                uuid: uuidV1,
                name: filename,
                size: 0,
                porcent: 0,
            };
            // Agregamos el item que estaremos usando para actualizar su propoedades
            this.addZipFile(data);

            // obtenemos el index para retornarlo y poder asignarle sus valores en vuelo
            const idx = Object.values(this.$store.state.zip.data).findIndex(
                (item) => item.uuid == uuidV1
            );
            return idx;
        },
        /* The above code is downloading a file in chunks and then concatenating the chunks to form the
        original file. */
        async download({ url, chunkSize, idx, poolLimit = 1 }) {
            const contentLength = await this.getContentLength(url);
            const formatBytes = this.formatBytes(contentLength);
            this.$store.dispatch("setDownloadContentLength", {
                idx,
                data: { contentLength, formatBytes },
            });

            const chunks =
                typeof chunkSize === "number" ?
                    Math.ceil(contentLength / chunkSize) :
                    1;
            const results = await this.asyncPool(
                poolLimit, [...new Array(chunks).keys()],
                (i) => {
                    let start = i * chunkSize;
                    let end =
                        i + 1 == chunks ?
                            contentLength - 1 :
                            (i + 1) * chunkSize - 1;
                    let binaryContent = this.getBinaryContent(
                        url,
                        start,
                        end,
                        i
                    );
                    let porcentDownload = this.binaryContentDowloaded(
                        binaryContent,
                        idx
                    );

                    return binaryContent;
                }
            );


            const sortedBuffers = results.map(
                (item) => new Uint8Array(item.buffer)
            );

            return this.concatenate(sortedBuffers);
        },
        /* Downloading a file in chunks. */
        multiThreadedDownload(url, idx) {
            if (!url || !/https?/.test(url)) return;

            this.download({
                url,
                chunkSize: 1 * 1024 * 1024,
                idx,
                poolLimit: 6,
            })
                .then((buffers) => {

                    this.saveAs({
                        buffers,
                        idx,
                    });
                })
                .catch(function (err) {

                });
        },
        async directDownloadFileAction(url, idx) {
            const data = this.$store.state.downloaded.data[idx];
            const link = document.createElement("a");
            link.href = url;
            link.download = data.name;
            link.click();
        },
        /**
         * *Send the request to zipGenerator Api and then update some store info
         * @param idx : id to update the correct info box
         * @param data : estructura para el envio de informacion al api
         * {
         *  JoinedCode : "DownloadCode"
            NumMedios : int multimedio quantity
            NumberPage : int number page
            Paths : [
                0 : https://bucket-aws/park/path-file.jpg
            ]
         * } 
         * @created : 2023-02-02
         * @validated : yeap.
         */
        async getCompressMedia(idx, data, zipFileName) {
            this.$store.dispatch("setDownloadState", { idx, data: 1 });
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/GetPhotosByZip", data)
                    .then((res) => {
                        let index = this.$store.state.downloaded.data.findIndex((el) => el.name === zipFileName);

                        this.$store.dispatch("setZipCompressed", (this.$store.state.zip.compressed + 1));
                        resolve({ data: res.data, idx: index });
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * *Start the current zip album download sending the request to getPhotos and then zip the photos using the response data. 
         * @created : 2023-02-02
         * @validated : yeap.
         */
        async compressZipPhotos(inMemoryResponse = null) {
            try {
                /**
                 * TODO: We can improve this part from my point of view, we can validate if we have this information before send the request and also check if we have downloable info.
                 */
                let mediaPagesResponse = inMemoryResponse;
                let zipPrefix = inMemoryResponse === null ? 'PAGE' : `SLP-${mediaPagesResponse[0].NumberPage}`;
                if (mediaPagesResponse === null) {
                    mediaPagesResponse = await this.$store.dispatch(
                        "getPhotos", {
                        page: this.page,
                        type: this.type,
                        free: true,
                        albumKey: this.album.AlbumKey,
                    }
                    );
                }

                // Verificamos que los multimedios comprimir esten listo y no se tenga algun problema para guardar el log
                if (mediaPagesResponse.length && inMemoryResponse === null) {
                    // Guardamos la cantidad de imagenes descargadas por ZIP en el log
                    let parameters = {
                        joinedCode: this.albumes.code,
                        parkId: this.parkID,
                        mediaTotal: this.totalMedia,
                        mediaDownload: this.totalMedia,
                        device: this.detectBrowser()
                    };
                    this.$store.dispatch("AddMediaLog", parameters);
                }

                this.$store.dispatch('setDownloadedCompressingZipTotal', mediaPagesResponse.length);
                this.$store.dispatch('setProgressingMultimedia', true);
                Promise.all(mediaPagesResponse.map(async (zipItemResponse) => {
                    const counterZipName = inMemoryResponse === null ? zipItemResponse.NumberPage : mediaPagesResponse[0].Paths.length;
                    const zipFileName = this.createZipName(this.albumes.code, counterZipName, zipPrefix);
                    const zipDataInMemory = this.searchDownloadbleZipName(`${zipFileName}.zip`);
                    if (zipDataInMemory.length > 0) {
                        Vue.$toast.open({
                            message: this.$tc("download.file_already_exists", zipFileName),
                            type: "info"
                        });
                    } else {
                        this.infoStartDownload(zipFileName, true);
                        await this.createZipCompress(zipItemResponse, zipFileName, mediaPagesResponse.length);
                    }
                })).then(() => {
                    this.$store.dispatch("setDownloadedCompressingZipTotal", 0);
                    this.$store.dispatch("setDownloadedCompressingZipCompressed", 0);
                    this.$store.dispatch('setProgressingMultimedia', false);
                    this.$store.dispatch("setZipTotal", (this.$store.state.zip.total + mediaPagesResponse.length));
                });

            } catch (error) {

            }
        },
        async downloadVideo(src) {
            let dframe = this.directDownloadWithIframe(src, uuid.v1(), 0);
            this.removeDownloableIframeElement(dframe);
            // Guardamos registro de descarga de video
            let parameters = {
                joinedCode: this.albumes.code,
                parkId: this.parkID,
                mediaTotal: 1,
                mediaDownload: 1,
                device: this.detectBrowser(),
            };

            // Verificamos que no sean fotos de albumes de regalo
            if (!this.$route.query.freeGallery)
                await this.$store.dispatch("AddMediaLog", parameters);
        },
        async downloadPhoto(src) {
            const idx = this.infoStartDownload(src);
            this.directDownloadFileAction(src, idx); //Replace  using directDownloadWithIframe() 
            this.$store.dispatch("setDownloadState", { idx, data: 3 });
        },
        /**
         * *Build zips and generates the list to download manualy, just if quantity is less o equal two the 
         * *direct download function will be fired. 
         * @param zipItem : this will have the item page data and unsingned urls compress as zip
         * @param zipFileName : should contain a string name related to the zipfile with this structure : DOWNLOADCODE-PAGE(NumberPage)
         * @created : 2023-02-02
         * @validated : yeap.
         */
        async createZipCompress(zipItem, zipFileName = null, currentTotalPages = 0, dowloadInfoPosition = 0) {
            if (this.mediaPagesPosition < currentTotalPages) {
                this.$store.dispatch('setDownloadedCompressingZipCompressed', (this.$store.state.downloaded.compressingZip.compressed + 1));
                const zip = await this.getCompressMedia(dowloadInfoPosition, zipItem, `${zipFileName}.zip`);
                dowloadInfoPosition = zip.idx;

                this.$store.dispatch("setDownloadState", { idx: dowloadInfoPosition, data: 1 });

                const url = this.removeLineBreaks(zip.data.url);
                if (currentTotalPages <= 2) {
                    const createdElement = this.directDownloadWithIframe(url, 'downloadZip', dowloadInfoPosition);
                    this.removeDownloableIframeElement(createdElement);
                }

                this.$store.dispatch("setDownloadUrl", { idx: dowloadInfoPosition, data: url });
                this.$store.dispatch("setDownloadState", { idx: dowloadInfoPosition, data: 3 });
                this.mediaPagesPosition++;
            }
        },
        /**
         * * This method will validated if the zips names exist to prevent a new download request.
         * @zipName : should contain the zip name with this estructure DOWNLOADCODE-PAGE(NUMBERPAGE).zip
         * TODO : here is an example about why we need stard way to make the file name, in this case to zips[ REF FUNCTION: addNewDownload]
         */
        searchDownloadbleZipName(zipName) {
            return this.$store.state.downloaded.data.filter((zipItem) => zipItem.name === `${zipName}`);
        },
        /**
         * * This function creates an element IFRAME to download any file
         * @url : file path to download
         * @className : this should will help us to define the download type [downloadlePhoto | downloadZip]
         * @downloadleFilePosition : this should contain the file position, this is an extra idenfitier.
         */
        directDownloadWithIframe(url, className, downloadleFilePosition) {
            const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');

            let targetBlank = {};
            let elementType = 'iframe';
            let srcAttribute = { src: url };
            if (isFirefox && downloadleFilePosition === 0) {
                elementType = 'a';
                targetBlank = { target: '_blank' };
                srcAttribute = { href: url };
            }

            const downloableFile = Object.assign(document.createElement(elementType), {
                id: `${className}-${downloadleFilePosition}`,
                ...srcAttribute,
                classList: `hidden ${className}-${downloadleFilePosition}`,
                ...targetBlank
            });
            document.body.appendChild(downloableFile);

            if (isFirefox && downloadleFilePosition === 0) {
                downloableFile.click();
            }

            return downloableFile;
        },
        removeDownloableIframeElement(downloableFile) {
            setTimeout(() => {
                document.body.removeChild(downloableFile);
            }, 1000);
        },
        /**
         * * build the zip name, using the current route parkID to specifie from which album will gonna generate the zip
         * @downloadCode : download code 
         * @counter : this should will help us to define the download type [numberPage or selected Photos Quantity]
         * @needExtension : by default is null, if we need add an extension just pass as string '.zip'
         * @zipType : by default the file name will have PAGE({counter}), but when the zip isn't all pages should have SLP({counter})
         */
        createZipName(downloadCode, counter, zipType, needExtension = '') {
            let prefixPark = '';
            Object.values(this.$store.state.albumes).map((album) => {
                if (album.code === downloadCode) {
                    const park = album.park;
                    if (park.length > 1) {
                        const selectedAlbumParkId = parseInt(this.$route.query.parkID);
                        park.filter((currentPark) => {
                            if (currentPark.Park.Id === selectedAlbumParkId) {
                                prefixPark = currentPark.Park.Prefix;
                            }
                        });
                    } else {
                        prefixPark = park[0].Park.Prefix;
                    }
                }
            });
            return `${downloadCode}-${prefixPark}-${zipType}(${counter})${needExtension}`;
        },
        /**
         * The function detects the type of device (Android, iPhone, or PC) based on the user agent
         * string.
         * @returns a string that represents the type of device based on the user agent string. It can
         * be "Android" if the user agent string contains "android", "iPhone" if it contains "iphone",
         * or "PC" if it doesn't match either of those.
         */
        detectBrowser() {
            let userAgent = navigator.userAgent;
            let device;

            if (userAgent.match(/android/i)) {
                device = "Android";
            } else if (userAgent.match(/iphone/i)) {
                device = "iPhone";
            } else {
                device = "PC";
            }

            return device;
        }
    }
}